module.exports = __webpack_public_path__ + "assets/icons/ic_access_time-eddd.svg";